import { DirtyLittleSecret } from '../../../src/components'
import Footers from '../../../src/components/Footer'
import Header from '../../../src/components/Header'

export default function AccessibilityPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <DirtyLittleSecret />
      </div>
      <Footers />
    </>
  )
}
